import { useCompanyRelativePath, useGetOGPUserInfo } from 'ogp/hooks';
import { useCallback } from 'react';
import { BulkArchiveSidebar } from 'shared/components/bulk/bulk-shift-action/bulk-archive-sidebar';
import { BulkEditSidebar } from 'shared/components/bulk/bulk-shift-action/bulk-edit-sidebar';
import { WorkFormSidebar } from 'shared/components/work-forms/work-form-sidebar';
import { WorkFormCompanyInfo } from 'shared/components/work-forms/work-form.types';
import { RenderUnsettledUI } from 'shared/components';
import { useLocation, useNavigate } from 'react-router-dom';
import { paths } from 'ogp/paths';
import { BulkShiftCreationSidebar } from 'shared/components/bulk/bulk-shift-action/bulk-shift-creation-sidebar';
import { useIsHqAdmin } from 'shared/hooks';
import { usePlanningContext } from './providers/planning-actions-provider';

export const PlanningSidebar = () => {
  const { selectedShiftIds, sidebarState, setSidebarState } = usePlanningContext();
  const userInfoQuery = useGetOGPUserInfo();
  const generatePath = useCompanyRelativePath();
  const navigate = useNavigate();
  const { search } = useLocation();
  const isHqAdmin = useIsHqAdmin();

  const handleWorkFormSuccess = useCallback(
    (shiftId: string) => {
      const activeRoute = location.pathname.split('/').pop();
      const filterParams = Object.fromEntries(new URLSearchParams(search));
      const mergedParams = { ...filterParams, shiftId };
      const path = generatePath(paths.ShiftPlanning, undefined, mergedParams, activeRoute);
      navigate(path);
    },
    [search]
  );
  if (userInfoQuery.status !== 'success') {
    return <RenderUnsettledUI data={userInfoQuery} />;
  }

  const { data: userInfo } = userInfoQuery;
  const companies: WorkFormCompanyInfo[] = [
    {
      ...userInfo.userInfo.company,
      id: userInfo.userInfo.company.slug,
    },
  ];

  return (
    <>
      <BulkEditSidebar
        selectedShiftIds={selectedShiftIds}
        isBulkSideBarOpen={sidebarState === 'bulk-edit'}
        setIsBarSideBarOpen={() => setSidebarState(null)}
      />
      <BulkArchiveSidebar
        selectedShiftIds={selectedShiftIds}
        isBulkArchiveBarOpen={sidebarState === 'bulk-archive'}
        setIsBarSideBarOpen={() => setSidebarState(null)}
      />
      {sidebarState === 'create' || sidebarState === 'edit' || sidebarState === 'duplicate' ? (
        <WorkFormSidebar
          isSidebarOpen={true}
          closeSidebar={() => setSidebarState(null)}
          companies={companies}
          formMode={sidebarState}
          selectedShiftIds={selectedShiftIds}
          isHqAdmin={isHqAdmin}
          onSuccess={handleWorkFormSuccess}
        />
      ) : null}
      {sidebarState === 'bulk-shift-creation' ? (
        <BulkShiftCreationSidebar isOpen={true} setIsBarSideBarOpen={() => setSidebarState(null)} />
      ) : null}
    </>
  );
};
